export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "resamplerWorker.65264e816270cdacfa89.js");
}
